import Geometry from '@arcgis/core/geometry/Geometry';
import { outagesPolygonLayer } from '../layers/outages.layer';

export function createQueryParams(geometry: Geometry) {
  const queryParams = outagesPolygonLayer.createQuery();

  queryParams.geometry = geometry; //location of a search result
  queryParams.spatialRelationship = 'intersects';
  queryParams.returnGeometry = false;
  queryParams.outFields = ['OBJECTID'];

  return queryParams;
}
